import LayoutComponent from "../components/LayoutComponent";
import ImageUpload from "../components/ImageUpload";
import {useEffect, useState} from "react";
import {Button} from "antd";
import {useApi} from "../provider/ApiProvider";

export default function FoodListPage(){
    const {api} = useApi();

    const [imageData, setImageData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
        load()
    },[])

    async function load(){
        setLoading(true);
        await api.get('/appConfigRouter/config/get').then(resp => {
            setData(resp.data);
        }).finally(() => setLoading(false));
    }

    async function onChangeImageUpload(value){
        setImageData(value);
    }

    async function save(){
        let formData = new FormData();
        formData.append('blob',imageData, "new-image");
        setLoading(true);
        await api.upload("/uploadRouter/image/save",formData).then(resp => {
            if(resp.data.status === true){
                updateOptions(resp.data.name);
            }
        }).finally(() => setLoading(false))
    }

    async function updateOptions(imageLink){
        setLoading(true);
       await api.post('/appConfigRouter/config/update-food-list',{foodList: imageLink}).then(resp => {
           load()
       }).finally(() => setLoading(false));
    }

    return (<>
      <div>
          <LayoutComponent
              title={"Yemek Listesi"}
              subTitle={"Yemek listesi resmi seçnizin ve yükle butonuna basınız"}
              links={
                  [
                      {
                          title: 'Yemek Listesi',
                          url: '/food-list',
                      },

                  ]}
          >
              <div className="image-upload-box">
                  <div className="upload-area">
                      <ImageUpload value={imageData} name={"image"} onChange={onChangeImageUpload} />
                      <Button  onClick={save}>Yükle</Button>
                  </div>
                  <div className="image-area">
                      {(data && data.foodList) && (
                          <img className="image-box" src={data.foodList}/>
                      )}
                  </div>
              </div>
          </LayoutComponent>
      </div>
    </>)
}